import { Paper, styled } from '@mui/material';

export const StyledProgramInfoBookWrap = styled(Paper)({
	borderRadius: '4px',
	padding: '4px',
	gap: '8px',
	display: 'flex',
	width: '100%',
	textAlign: 'center',
});

export const StyledProgramInfoBookImage = styled('img')(() => ({
	borderRadius: '4px',
	objectFit: 'cover',
	width: '75px',
	height: '100px',
}));

export const StyledProgramInfoBookTextBlock = styled('div')({
	paddingBlock: '4px',
	display: 'flex',
	gap: '4px',
	justifyContent: 'space-between',
});
